import { Injectable } from "@angular/core";
import { ncbMandatory } from '../careconfig/NcbSuperMandatoryPincode';

@Injectable({
    providedIn: "root",
  })

  export class CareAddvantageCheck {

    public checkNCBSuper (addons: any, members: any, pincode: string) {
        const pin = parseInt(pincode ,10)
        const eldestAge = members
        .map((member: { date_of_birth: any; }) => this.calculateAge(member.date_of_birth))  
        .reduce((maxAge: number, age: number) => Math.max(maxAge, age), 0); 
        if((eldestAge < 46  &&  ncbMandatory.includes(pin)) && !addons.includes('CAREADWITHNCB')  ) {
         return true
        } else if (eldestAge >75 && eldestAge < 100 ) {
            return true
        } else {
            return false
        }
           

    }
    checkGlobalAddons () {
       const  careSI = JSON.parse(localStorage.getItem('carePremiumPayload'))
       const amount = parseInt(careSI.SI ,10) 
       if(amount >= 20000000 && amount <= 60000000)   {
        return true
       }else {
        return false
       }
     
    } 
   private calculateAge(dob: { yy: any; mm: any; dd: any; }) {
    const birthDate = new Date(`${dob.yy}-${dob.mm}-${dob.dd}`);
    const today = new Date();
    
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
  
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
  }